<template>
  <div class="popup_wrap" style="width:380px; height:430px;overflow:none;">
    <button class="layer_close" @click="$emit('close')">close</button>

    <div class="popup_cont cod_cont_area">
      <!-- popup_cont -->
      <h1 class="page_title">
        {{ $t('msg.ONEX010T010.161') }}
      </h1>
      <div class="content_box">
        <div class="clearfix">
          <div class="float_left">
            <table class="tbl_list font_sm gridtype" style="border: 1px solid #e1e3eb;">
              <colgroup>
                <col width="10%">   <!-- No. -->
                <col width="40%">   <!-- Container No. -->
                <col width="25%">   <!-- Weight -->
                <col width="30%">   <!-- Package ← 폭 확보 -->
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>{{ $t('msg.ONEX050G020.003') }}</th>
                  <th>{{ $t('msg.ONEX050G020.018') }}</th>
                  <th>{{ $t('msg.ONEX050G020.045') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(vo, idx) in list" :key="idx">
                  <td>{{ vo.rowCd }}</td>
                  <td>{{ vo.cntrNo }}</td>
                  <td style="text-align: end;">{{ vo.rmk.replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
                  <td>{{ vo.pkg }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <span class="ml_auto cal_btn"><a class="button sm" href="#" @click.prevent="exlDownload()">{{ $t('msg.MYIN020T010.016') }}</a></span>  <!-- 엑셀 다운로드 -->
        </div>
        <div class="normal_box" style="background-color: #FFF4F2">
          <ol>
            <li style="color: #ff0000; white-space: pre-line; list-style: none; display: table; margin: 0 auto; text-align: left; font-weight: 500">{{ $t('msg.ONEX010T010.176') }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import trans from '@/api/rest/trans/importSvc'
import { rootComputed } from '@/store/helpers'
import XLSX from 'xlsx'

export default {
  name: 'CntrSearchPop',
  components: {
    rootComputed
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          blNo: '',
          podCtrCd: ''
        }
      }
    }
  },
  data () {
    return {
      list: []
    }
  },
  computed: {
    ...rootComputed
  },
  watch: {
    parentInfo () {
    }
  },
  created () {
    this.initPop()
  },
  methods: {
    async initPop () {
      //bkgNo없으면 blNo가져오기 처리
      const parentInfo = this.parentInfo
      if (this.$ekmtcCommon.isEmpty(parentInfo.blNo)) {
        const TH = this
        this.$ekmtcCommon.alertCallback(this.$t('msg.ONEX070G050.004'), () => {
          TH.$emit('close')
        })
      }

      this.init()
    },
    async init () {
      const TH = this
      const parentInfo = TH.parentInfo
      const blNo = parentInfo.blNo
      const params = {
        blNo: blNo
      }
      await trans.getCntrList(params)
      .then(res => {
        console.log('getCntrList res @@@@ ', res.data)
        this.list = res.data
      })
    },
    exlDownload () {
      let excelData = []

      for (const vo of this.list) {
        const excelLogs = {
          No: vo.rowCd,
          Container_No: vo.cntrNo,
          Weight: vo.rmk.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          Pkgs: vo.pkg
        }
        excelData.push(excelLogs)
      }

      const workSheet = XLSX.utils.json_to_sheet(excelData)
      const workBook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workBook, workSheet, '컨테이너별 중량 조회')
      XLSX.writeFile(workBook, '컨테이너별 중량 조회.xlsx')
    }
  }
}
</script>

<style scoped>
.float_left{
  overflow-y: scroll;
  height: 170px;
  width: 100%;
  -ms-overflow-style: none; /* 인터넷 익스플로러 */
  scrollbar-width: none; /* 파이어폭스 */
}

.float_left::-webkit-scrollbar {
  display: none; /* 크롬, 사파리, 오페라, 엣지 */
}
</style>
